var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "forum" },
    [
      _c("SectionTitle", { attrs: { title: "意见汇总" } }),
      _c("section", { staticClass: "forum-section" }, [
        _c(
          "div",
          { staticClass: "forum-section--btn" },
          [
            _vm.ruleForm.status !== 3
              ? _c(
                  "el-button",
                  {
                    staticStyle: { width: "160px" },
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.issueOpinion },
                  },
                  [_vm._v("发表意见")]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm.tableData.length > 0
          ? _c(
              "div",
              { staticClass: "section-main" },
              _vm._l(_vm.tableData, function (item) {
                return _c(
                  "div",
                  { key: item.id, staticClass: "section-main--item" },
                  [
                    _c("div", { staticClass: "main-item--left" }, [
                      _c("div", { staticClass: "item-title" }, [
                        _c("p", [
                          _c(
                            "span",
                            {
                              staticClass: "item-title--name",
                              attrs: { title: item.proposer },
                            },
                            [_vm._v(_vm._s(item.proposer))]
                          ),
                          _vm._v("（" + _vm._s(item.deptName) + "） "),
                          _c("span", { staticClass: "item-title--time" }, [
                            _vm._v(_vm._s(item.submitTime)),
                          ]),
                        ]),
                        _c(
                          "div",
                          [
                            _vm.$route.query.type == "1"
                              ? [
                                  !item.isTop && _vm.ruleForm.status !== 3
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.topHandle(item)
                                            },
                                          },
                                        },
                                        [_vm._v("置顶")]
                                      )
                                    : _vm._e(),
                                  item.isTop && _vm.ruleForm.status !== 3
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.topNoHandle(item)
                                            },
                                          },
                                        },
                                        [_vm._v("取消置顶")]
                                      )
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                            item.isOwner
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.delAllHandle(item)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                            _vm.ruleForm.status !== 3
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.reply("主", item)
                                      },
                                    },
                                  },
                                  [_vm._v("回复")]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "item-like",
                                on: {
                                  click: function ($event) {
                                    return _vm.likeHanlde(1, item)
                                  },
                                },
                              },
                              [
                                !item.isLike
                                  ? _c("img", {
                                      attrs: {
                                        src: require("@/assets/images/zan-no.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                item.isLike
                                  ? _c("img", {
                                      attrs: {
                                        src: require("@/assets/images/zan-yi.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                _c(
                                  "span",
                                  { staticClass: "item-title--count" },
                                  [_vm._v(_vm._s(item.likeCount))]
                                ),
                              ]
                            ),
                          ],
                          2
                        ),
                      ]),
                      _c("div", { staticClass: "item-content" }, [
                        _vm._v(" " + _vm._s(item.content) + " "),
                      ]),
                    ]),
                    item.detailsList.length > 0
                      ? _c(
                          "div",
                          { staticClass: "main-item--right" },
                          _vm._l(item.detailsList, function (items) {
                            return _c(
                              "div",
                              { key: items.id, staticClass: "right-item" },
                              [
                                _c("div", { staticClass: "item-title" }, [
                                  _c("p", [
                                    _vm._v(
                                      " " +
                                        _vm._s(items.replyer) +
                                        "（" +
                                        _vm._s(items.deptName) +
                                        "） "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "item-title--time" },
                                      [_vm._v(_vm._s(items.submitTime))]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    [
                                      items.isOwner
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.delHandle(items)
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          )
                                        : _vm._e(),
                                      _vm.ruleForm.status !== 3
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.reply("次", items)
                                                },
                                              },
                                            },
                                            [_vm._v("回复")]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "item-like",
                                          on: {
                                            click: function ($event) {
                                              return _vm.likeHanlde(2, items)
                                            },
                                          },
                                        },
                                        [
                                          !items.isLike
                                            ? _c("img", {
                                                attrs: {
                                                  src: require("@/assets/images/zan-no.png"),
                                                  alt: "",
                                                },
                                              })
                                            : _vm._e(),
                                          items.isLike
                                            ? _c("img", {
                                                attrs: {
                                                  src: require("@/assets/images/zan-yi.png"),
                                                  alt: "",
                                                },
                                              })
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "item-title--count",
                                            },
                                            [_vm._v(_vm._s(items.likeCount))]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("div", { staticClass: "item-content" }, [
                                  _vm._v(" 回复"),
                                  items.respondent
                                    ? _c(
                                        "span",
                                        { staticClass: "item-content--name" },
                                        [
                                          _vm._v(
                                            _vm._s(items.respondent) +
                                              "（" +
                                              _vm._s(items.respondentDeptName) +
                                              "）"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v("：" + _vm._s(items.content) + " "),
                                ]),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]),
      _c("opinion", {
        ref: "opinion",
        on: { opinionEmit: _vm.opinionEmitHandle },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visiter,
            width: "600px",
            title: "回复",
            "before-close": _vm.cancelClick,
            "destroy-on-close": true,
            "modal-append-to-body": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "dialog-btns" },
                    [
                      _c("el-button", { on: { click: _vm.cancelClick } }, [
                        _vm._v("取消"),
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.submit },
                        },
                        [_vm._v("确定")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "回复内容：", prop: "content" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "2000",
                      "show-word-limit": "",
                      autosize: { minRows: 8, maxRows: 8 },
                    },
                    model: {
                      value: _vm.formData.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "content", $$v)
                      },
                      expression: "formData.content",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }